import { AddPicturesFromIncidentFormModalContext } from '@/contexts'
import { useContext } from 'react'

export const useAddPicturesFromIncidentFormModalContext = () => {
  const context = useContext(AddPicturesFromIncidentFormModalContext)

  if (!context) throw new Error('useAddPicturesFromIncidentFormModalContext has to be wrapped by AddPicturesFromIncidentFormModalContextProvider')

  return context
}
